import './side-form.component.scss';

export default {
  template: require('./side-form.component.html'),
  bindings: {
    id: "@vuiId"
  },
  transclude: true,
  controller: function ($scope, $timeout, $element, vuiSideForm) {
    'ngInject';

    const self = $scope.$ctrl;

    self.$onInit = () => {
      self._$form = $element.children();
      vuiSideForm.register(self.id, $scope);
    }

    $scope.open = () => {
      self._$form.removeClass('vui-side-form-container__hide');
      self._$form.addClass('vui-side-form-container__hide--animated');
      $timeout(() => {
        self._$form.removeClass('vui-side-form-container__hide--animated');
      });
    };

    $scope.close = () => {
      self._$form.addClass('vui-side-form-container__hide--animated');
      $timeout(() => {
        self._$form.addClass('vui-side-form-container__hide');
        self._$form.removeClass('vui-side-form-container__hide--animated');
      }, 250);
    };

    $scope.$on('$destroy', () => vuiSideForm.unregister(self.id));
  }
};
